import type { NavigateFn } from "@tanstack/react-router";
import type { LibraryItem } from "../lib/useLibrary";

type ItemLocation =
	| {
			to: "/doc/$docId";
			params: { docId: string };
			search: { highlight: undefined };
	  }
	| {
			to: "/content/$contentId";
			params: { contentId: string };
			search: { highlight: undefined };
	  };

export function getItemTitle(item: LibraryItem): string {
	if (item.source_type === "document" && item.title) {
		return item.title;
	}
	if (item.contents) {
		return item.contents.title || item.contents.canonical_url;
	}
	return "Untitled";
}

export function getItemSummary(item: LibraryItem): string | null {
	return item.summary ?? item.contents?.summary ?? null;
}

export const ITEM_TYPE_DISPLAY: Record<string, string> = {
	youtube_video: "YouTube Video",
	ai_thread: "AI Thread",
	website: "Website",
	url: "URL",
	document: "Document",
	upload: "Upload",
};

export function formatDate(iso: string): string {
	return new Date(iso).toLocaleDateString("en-US", {
		month: "short",
		day: "numeric",
	});
}

export function getItemLocation(item: LibraryItem): ItemLocation | null {
	if (item.source_type === "document") {
		return {
			to: "/doc/$docId",
			params: { docId: item.id },
			search: { highlight: undefined },
		};
	}

	if (item.content_id) {
		return {
			to: "/content/$contentId",
			params: { contentId: item.content_id },
			search: { highlight: undefined },
		};
	}

	return null;
}

export function navigateToItem(navigate: NavigateFn, item: LibraryItem): void {
	const location = getItemLocation(item);

	if (location) {
		navigate(location);
	}
}
